import { init } from 'trackux'

let hasTrackedInitialMetaPageView = false

function trackMetaPageView() {
  if (typeof window === 'undefined') return

  if (!hasTrackedInitialMetaPageView) {
    hasTrackedInitialMetaPageView = true
    return
  }

  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView')
  }
}

export const onRouteUpdate = () => {
  trackMetaPageView()
}

// TrackUX init (managed by `npx trackux`)
init({
  projectId: 'proj_98b7cb7b87be41f586782db543af387a',
  publicKey: 'pub_bdaff88938d24a399adebf3517beb73e',
  endpoint: 'https://trackux-ingestion.frank-bonnet.workers.dev',
  environment: 'production',
  autoCapture: {
    pageViews: true,
    clicks: true,
    behavior: true,
    forms: true,
    scrollDepth: false,
  },
})
